// Guaranteed to be unique by fair dice roll. (see RFC 1149.5)
export default 'defaultFluxKey_f8KfYJm6kWsX';
